type Props = {
  name: string;
  level: number;
};

export default function BusinessModalTitle({ name, level }: Props) {
  return (
    <div className="flex items-center gap-2.5">
      <p className="text-20 font-bold leading-none">{name}</p>
      <div className=" bg-white flex items-center gap-1 py-[0.3125rem] pl-[0.3125rem] pr-[0.4375rem] rounded-[0.3125rem] uppercase">
        <div className="size-2 mx-0.5 bg-dark-900 rounded-[0.125rem] rotate-45" />
        <div className="text-12 text-[#0F0F0F] font-bold leading-0">{level}</div>
      </div>
    </div>
  );
}
